/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Fresh_PicksInputs */

const en_directory_launch_fresh_picks = /** @type {(inputs: Directory_Launch_Fresh_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fresh picks`)
};

const zh_directory_launch_fresh_picks = /** @type {(inputs: Directory_Launch_Fresh_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本周新收录`)
};

/**
* | output |
* | --- |
* | "Fresh picks" |
*
* @param {Directory_Launch_Fresh_PicksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_fresh_picks = /** @type {((inputs?: Directory_Launch_Fresh_PicksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Fresh_PicksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_fresh_picks(inputs)
	return zh_directory_launch_fresh_picks(inputs)
});
export { directory_launch_fresh_picks as "directory.launch.fresh_picks" }